import { useState } from 'react';
import { Switch } from '@headlessui/react';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Configuracion() {
  const [settings, setSettings] = useState({
    exportarAutomaticamente: false,
    notificaciones: true,
    mostrarEstadisticasAvanzadas: false,
    modoOscuro: false,
    idiomaEspanol: true
  });

  const handleSettingChange = (setting) => {
    setSettings(prev => ({
      ...prev,
      [setting]: !prev[setting]
    }));
  };

  return (
    <div className="min-h-screen bg-gray-50/50">
      <div className="px-4 sm:px-6 lg:px-8 py-8">
        <div className="mx-auto max-w-4xl">
          <div className="space-y-6">
            {/* Título de la página */}
            <div>
              <h2 className="text-2xl font-bold leading-7 text-gray-900">Configuración</h2>
              <p className="mt-1 text-sm leading-6 text-gray-500">
                Personaliza tu experiencia en el dashboard de Worky
              </p>
            </div>

            {/* Sección Principal */}
            <div className="bg-white shadow rounded-lg">
              <div className="divide-y divide-gray-200">
                {/* Exportación */}
                <div className="px-4 py-6 sm:p-6">
                  <div className="text-base font-semibold leading-7 text-gray-900">
                    Exportación de Datos
                  </div>
                  <div className="mt-4 space-y-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <span className="text-sm font-medium text-gray-900">Exportar automáticamente</span>
                        <p className="text-sm text-gray-500">
                          Genera automáticamente reportes semanales en Excel
                        </p>
                      </div>
                      <Switch
                        checked={settings.exportarAutomaticamente}
                        onChange={() => handleSettingChange('exportarAutomaticamente')}
                        className={classNames(
                          settings.exportarAutomaticamente ? 'bg-primary' : 'bg-gray-200',
                          'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out'
                        )}
                      >
                        <span className="sr-only">Usar configuración del sistema</span>
                        <span
                          className={classNames(
                            settings.exportarAutomaticamente ? 'translate-x-5' : 'translate-x-0',
                            'pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                          )}
                        />
                      </Switch>
                    </div>
                  </div>
                </div>

                {/* Notificaciones */}
                <div className="px-4 py-6 sm:p-6">
                  <div className="text-base font-semibold leading-7 text-gray-900">Notificaciones</div>
                  <div className="mt-4 space-y-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <span className="text-sm font-medium text-gray-900">Activar notificaciones</span>
                        <p className="text-sm text-gray-500">
                          Recibe notificaciones sobre nuevos estudiantes y actualizaciones
                        </p>
                      </div>
                      <Switch
                        checked={settings.notificaciones}
                        onChange={() => handleSettingChange('notificaciones')}
                        className={classNames(
                          settings.notificaciones ? 'bg-primary' : 'bg-gray-200',
                          'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out'
                        )}
                      >
                        <span className="sr-only">Activar notificaciones</span>
                        <span
                          className={classNames(
                            settings.notificaciones ? 'translate-x-5' : 'translate-x-0',
                            'pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                          )}
                        />
                      </Switch>
                    </div>
                  </div>
                </div>

                {/* Visualización */}
                <div className="px-4 py-6 sm:p-6">
                  <div className="text-base font-semibold leading-7 text-gray-900">Visualización</div>
                  <div className="mt-4 space-y-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <span className="text-sm font-medium text-gray-900">Estadísticas avanzadas</span>
                        <p className="text-sm text-gray-500">
                          Muestra métricas y gráficos adicionales en el dashboard
                        </p>
                      </div>
                      <Switch
                        checked={settings.mostrarEstadisticasAvanzadas}
                        onChange={() => handleSettingChange('mostrarEstadisticasAvanzadas')}
                        className={classNames(
                          settings.mostrarEstadisticasAvanzadas ? 'bg-primary' : 'bg-gray-200',
                          'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out'
                        )}
                      >
                        <span className="sr-only">Mostrar estadísticas avanzadas</span>
                        <span
                          className={classNames(
                            settings.mostrarEstadisticasAvanzadas ? 'translate-x-5' : 'translate-x-0',
                            'pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                          )}
                        />
                      </Switch>
                    </div>

                    <div className="flex items-center justify-between">
                      <div>
                        <span className="text-sm font-medium text-gray-900">Modo oscuro</span>
                        <p className="text-sm text-gray-500">
                          Cambia la apariencia del dashboard a modo oscuro
                        </p>
                      </div>
                      <Switch
                        checked={settings.modoOscuro}
                        onChange={() => handleSettingChange('modoOscuro')}
                        className={classNames(
                          settings.modoOscuro ? 'bg-primary' : 'bg-gray-200',
                          'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out'
                        )}
                      >
                        <span className="sr-only">Activar modo oscuro</span>
                        <span
                          className={classNames(
                            settings.modoOscuro ? 'translate-x-5' : 'translate-x-0',
                            'pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                          )}
                        />
                      </Switch>
                    </div>
                  </div>
                </div>

                {/* Idioma */}
                <div className="px-4 py-6 sm:p-6">
                  <div className="text-base font-semibold leading-7 text-gray-900">Idioma</div>
                  <div className="mt-4 space-y-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <span className="text-sm font-medium text-gray-900">Español</span>
                        <p className="text-sm text-gray-500">
                          Cambiar el idioma de la interfaz a español
                        </p>
                      </div>
                      <Switch
                        checked={settings.idiomaEspanol}
                        onChange={() => handleSettingChange('idiomaEspanol')}
                        className={classNames(
                          settings.idiomaEspanol ? 'bg-primary' : 'bg-gray-200',
                          'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out'
                        )}
                      >
                        <span className="sr-only">Cambiar a español</span>
                        <span
                          className={classNames(
                            settings.idiomaEspanol ? 'translate-x-5' : 'translate-x-0',
                            'pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                          )}
                        />
                      </Switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Botones de acción */}
            <div className="flex items-center justify-end space-x-4">
              <button
                type="button"
                className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                type="button"
                className="rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/90"
              >
                Guardar cambios
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 